import { render, staticRenderFns } from "./PostFeedByTag.vue?vue&type=template&id=7bf9e468&"
import script from "./PostFeedByTag.vue?vue&type=script&lang=js&"
export * from "./PostFeedByTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports